function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 15.5442C9.85652 15.5442 11.637 14.8067 12.9497 13.4939C14.2625 12.1812 15 10.4007 15 8.54419C15 6.68767 14.2625 4.9072 12.9497 3.59444C11.637 2.28169 9.85652 1.54419 8 1.54419C6.14348 1.54419 4.36301 2.28169 3.05025 3.59444C1.7375 4.9072 1 6.68767 1 8.54419C1 10.4007 1.7375 12.1812 3.05025 13.4939C4.36301 14.8067 6.14348 15.5442 8 15.5442ZM8 16.5442C10.1217 16.5442 12.1566 15.7013 13.6569 14.201C15.1571 12.7008 16 10.6659 16 8.54419C16 6.42246 15.1571 4.38763 13.6569 2.88734C12.1566 1.38704 10.1217 0.544189 8 0.544189C5.87827 0.544189 3.84344 1.38704 2.34315 2.88734C0.842855 4.38763 0 6.42246 0 8.54419C0 10.6659 0.842855 12.7008 2.34315 14.201C3.84344 15.7013 5.87827 16.5442 8 16.5442Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.92995 7.13208L6.63995 7.41908L6.55795 7.79908L7.00795 7.88208C7.30195 7.95208 7.35995 8.05808 7.29595 8.35108L6.55795 11.8191C6.36395 12.7161 6.66295 13.1381 7.36595 13.1381C7.91095 13.1381 8.54395 12.8861 8.83095 12.5401L8.91895 12.1241C8.71895 12.3001 8.42695 12.3701 8.23295 12.3701C7.95795 12.3701 7.85795 12.1771 7.92895 11.8371L8.92995 7.13208Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8 6.04419C8.55228 6.04419 9 5.59647 9 5.04419C9 4.4919 8.55228 4.04419 8 4.04419C7.44772 4.04419 7 4.4919 7 5.04419C7 5.59647 7.44772 6.04419 8 6.04419Z",
  fill: "white"
});

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.4c97035e.svg";
export { ForwardRef as ReactComponent };